<template>
  <va-card :title="$t('menu.deliveries')">
    <va-button
        medium
        inline
        color="#ff842b"
        icon="fa fa-chevron-left"
        class="ma-2"
        :to="{ name: 'deliveries', params: {
          current_page: this.$route.params.current_page,
          search: this.$route.params.search,
          delivery_date: this.$route.params.delivery_date,
          perPage: this.$route.params.perPage }
          }"
    >
          {{ $t('menu.back') }}
      </va-button>
    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="15"
      :loading="loading"
    >
    </va-data-table>

  </va-card>
</template>

<script>

import DeliveriesAPI from '@/services/DeliveriesAPI'
import moment from 'moment'

export default {
  name: 'modals',
  data () {
    return {
      data: [],
      loading: false,
      datepicker: {
        today: moment(new Date()).format('DD-MM-YYYY')
      },
      showModal: false,
    }
  },
  mounted () {
    this.readItems()
  },
  computed: {
    fields () {

      return [{
        name: 'id',
        title: this.$t('tables.deliveries.id'),
        width: '3%',
      },
      {
        name: 'sequence',
        title: this.$t('tables.deliveries.delivery_sequence'),
        width: '5%',
      },
      {
        name: 'client_name',
        title: this.$t('tables.deliveries.client_name'),
        width: '40%',
      },
      {
        name: 'product',
        title: this.$t('tables.deliveries.product'),
        width: '30%',
      },
      {
        name: 'quantity',
        title: this.$t('tables.deliveries.quantity'),
        width: '10%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  methods: {
    readItems() {
      this.loading = true

      DeliveriesAPI.getDeliveriesByLoadID(this.$route.params.loadID).then(response => {
        this.data = response.data.deliveries
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss">
</style>
